module.exports = __webpack_public_path__ + "static/img/3.353ecd7.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/website/3.jpeg
// module id = dZBU
// module chunks = 1